import Repository from "@/services/repository";

export default {
  getDataForEditorialBrief(studyId, keywordId) {
    return Repository.get(
      `/a/${studyId}/keywords/${keywordId}/export.json`
    ).then((response) => response.data);
  },
};
